import { IconButton, Stack, Typography, Box } from "@mui/material";
import NF from "assets/nf.png";
import SearchIcon from "@mui/icons-material/Search";
import { Button } from "@mui/material";
import TicketService from "services/ticket";
import { IconCopy } from "../../../../Icons/IconCopy";
import { useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import { formatInvoice } from "utils/Masks/Masks";
import { useContext } from "react";
import ApiContext from "api";
import ClienteService from "services/cliente";
import { toast } from "react-toastify";

export default function Invoice({ invoice }) {
  const [copy, setCopy] = useState(false);
  const { ConsigazApi } = useContext(ApiContext);

  const invoiceStatus = TicketService.getTicketStatus(invoice);

  const bgColor =
    invoiceStatus === "avencer" || invoiceStatus === "open"
      ? "#FF9703"
      : invoiceStatus === "paid"
      ? "#00A326"
      : invoiceStatus === "outdated"
      ? "#EA4C4B"
      : "#A2A2A2";

  const sendByEmail = () => {
    const { email, segmento } = ClienteService.localEntrega;
    const { email: emailContato } = ClienteService.industrialContato || {};

    if (
      (segmento !== "INDUSTRIAL" && !email) ||
      (segmento === "INDUSTRIAL" && !emailContato)
    ) {
      toast.error(
        "Parece que você não tem e-mail cadastrado. Entre no perfil e cadastre agora mesmo para poder receber suas contas!"
      );
      return null;
    }

    if (!invoice) return null;

    ConsigazApi.shareTicket(
      invoice["cod_estab"] ?? invoice["cod-estabel"],
      invoice["cod_ser_docto"] ?? invoice["serie"],
      invoice["cod_tit_acr"] ?? invoice["nr-nota-fis"]
    ).then(
      () =>
        toast.success(
          `A nota fiscal foi enviada para ${
            segmento === "INDUSTRIAL" ? emailContato : email
          }`
        ),
      () => toast.error("Erro ao enviar a nota fiscal.")
    );
  };

  function titleInvoice(invoice) {
    const cod_estab = String(invoice["cod_estab"] ?? invoice["cod-estabel"]).padStart(3, "0")
    const cod_espec_docto = "DM"
    const cod_ser_docto = invoice["cod_ser_docto"] ?? invoice["serie"]
    const cod_tit_acr = invoice["cod_tit_acr"] ?? invoice["nr-nota-fis"]
    const cod_parcela = "01"

    return `${cod_estab}|${cod_espec_docto}|${cod_ser_docto}|${cod_tit_acr}|${cod_parcela}`;
  }

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        mb={"24px"}
      >
        <Typography fontSize={"36px"} fontWeight={800} color={"#03A9F5"}>
          Boleto
        </Typography>
        <Stack
          borderRadius={"32px"}
          bgcolor={bgColor}
          textAlign={"center"}
          padding={"16px"}
        >
          <Typography fontSize={"16px"} fontWeight={600} color={"#FFFFFF"}>
            Boleto{" "}
            {invoiceStatus === "avencer" || invoiceStatus === "open"
              ? "a vencer"
              : invoiceStatus === "paid"
              ? "pago"
              : invoiceStatus === "outdated"
              ? "vencido"
              : "cancelado/devolvido"}
          </Typography>
        </Stack>
      </Stack>
      <Stack direction={"row"}>
        {copy ? (
          <Stack justifyContent={"center"} alignItems={"center"} mr={2}>
            <CheckIcon
              sx={{
                fontSize: "25px",
                color: "#053462",
              }}
            />
            <Typography fontSize={"12px"} fontWeight={700} color="#053462">
              copiado
            </Typography>
          </Stack>
        ) : (
          <IconButton
            onClick={() => {
              navigator.clipboard.writeText(
                invoice["linha-digitavel"],
                setCopy(true)
              );
            }}
            sx={{
              mr: 1.6,
            }}
          >
            <IconCopy />
          </IconButton>
        )}

        <Stack gap={1}>
          <Typography fontSize={"14px"} fontWeight={600} color="#636363">
            Código do boleto
          </Typography>
          <Typography fontSize={"24px"} fontWeight={700} color="#053462">
            {formatInvoice(invoice["linha-digitavel"]) || invoice["nr-nota-fis"]}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        position={"relative"}
        height={"216px"}
        border={"2px solid #05346299"}
        borderRadius={"8px"}
        mt={"24px"}
        justifyContent={"center"}
      >
        <Box
          component="img"
          src={NF}
          alt="Boleto Genérico"
          sx={{
            maxHeight: "100%",
            maxWidth: "100%",
            borderRadius: "8px",
            opacity: 0.5,
          }}
        />
        <Stack
          borderRadius={"8px"}
          bgcolor={"#32323287"}
          padding={"10px"}
          position={"absolute"}
          right={"45%"}
          onClick={() =>
            window.open(
              `/invoice-pdf?acao=ArquivoBoleto&titulo=${titleInvoice(invoice)}`
            )
          }
        >
          <SearchIcon
            sx={{
              color: "#FFFFFF",
              cursor: "pointer",
              fontSize: "50px",
            }}
          />
        </Stack>
      </Stack>
      <Stack gap={"24px"} mt={"24px"} direction={"row"}>
        <Button
          variant="contained"
          color="secondary"
          fullWidth
          sx={{
            height: "55px",
            color: "#fff",
          }}
          onClick={() => sendByEmail()}
        >
          Compartilhar por email
        </Button>
        <Button
          variant="contained"
          color="secondary"
          fullWidth
          sx={{
            height: "55px",
            color: "#fff",
          }}
          onClick={() =>
            ConsigazApi.downloadBoleto(titleInvoice(invoice), true)
          }
        >
          Baixar Boleto
        </Button>
      </Stack>
    </>
  );
}
